var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.588,
    height: 23.188,
    viewBox: "0 0 20.588 23.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f4ab40;}.b{fill:#ffcc5b;}.c{fill:#2f394e;}.d{fill:#e99d38;}.e{fill:#fdbc4b;}.f{fill:#20bead;}.g{opacity:0.1;}.h{fill:#010101;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.705)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.705 2.717)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M299.223,68.876h-.754a.724.724,0,0,1-.7-.9l1.811-7.427a.726.726,0,0,1,.7-.553h3.271a2.6,2.6,0,0,1,2.522,3.211l-.086.354A6.944,6.944,0,0,1,299.223,68.876Zm1.625-7.427-1.456,5.975a5.5,5.5,0,0,0,5.185-4.2l.086-.354a1.145,1.145,0,0,0-1.113-1.417Z",
    transform: "translate(-285.559 -60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.866,63.564l-.086-.354A2.6,2.6,0,0,1,31.3,60h3.271a.725.725,0,0,1,.7.553l1.811,7.427a.724.724,0,0,1-.705.9h-.754A6.943,6.943,0,0,1,28.866,63.564ZM31.3,61.449a1.146,1.146,0,0,0-1.114,1.417l.086.354a5.5,5.5,0,0,0,5.185,4.2L34,61.449Z",
    transform: "translate(-28.705 -60)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.616,32.064v5.977a6.116,6.116,0,0,0,2.349,4.829,4.412,4.412,0,0,1,1.724,4.138v0h4.117a4.417,4.417,0,0,1,1.724-4.15,6.116,6.116,0,0,0,2.348-4.821V32.064Z",
    transform: "translate(-87.749 -30.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M132.331,362.032H121.163a.547.547,0,1,0,0,1.094h11.168a.547.547,0,1,0,0-1.094Z",
    transform: "translate(-87.749 -345.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M132.331,487.84H121.163a.547.547,0,1,0,0,1.094h11.168a.547.547,0,1,0,0-1.094Z",
    transform: "translate(-87.749 -465.747)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 10.623,
    height: 4.603,
    transform: "translate(33.687 17.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M115.389,0H102.91a.726.726,0,0,0-.726.726h0a.726.726,0,0,0,.726.726h12.479a.726.726,0,0,0,.726-.726h0A.725.725,0,0,0,115.389,0Z",
    transform: "translate(-70.151)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.029 18.885)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "translate(6.124)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "translate(3.062)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M164.811,37.238,163.1,36.01,161.4,37.238V32.064h3.411Z",
    transform: "translate(-126.685 -30.612)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(32.886 1.449)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 12.223,
    height: 0.668
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.8c12fe2fb1bd10bf272457fca3198dd2.svg";
export { ForwardRef as ReactComponent };